import { contains } from 'jquery';
import * as _ from 'lodash';
import { format } from 'date-fns';
import * as React from 'react';
import DatePicker from 'react-datepicker';
import { Button } from 'reactstrap';
import { IFilters, userData } from '../../../util/userData';
import {BtnPopover} from '../BtnPopover';
import {BtnSelect} from '../BtnSelect';
import { CheckBox } from '../CheckBox';
import {DataBtnSelect} from '../DataBtnSelect';
import {DataMultiBtnSelect} from '../DataMultiBtnSelect';
import { FontAwesomeIcon } from '../FontAwesomeIcon';
import {Modal} from '../Modal';
import {CustomPeriodsFilter} from './components/CustomPeriodsFilter';
import { PeriodsFilter } from './components/PeriodsFilter';
import {
  CommentTypesDataSource,
  HierarchyDataSource,
  HierarchyMyAlertsDataSource,
  PeriodsDataSource,
  QuestionsDataSource,
  SegmentParentsDataSource,
  SegmentsDataSource,
  SourcesDataSource,
  SurveysDataSource,
} from './DataSources';

interface IIFiltersBarProps {
  hideSegments?: boolean;
  hideSurveys?: boolean;
  hideSearch?: boolean;
  hideQuestions?: boolean;
  showMultiQuestionsFilter?: boolean;
  hideMetrics?: boolean;
  hideHeirarchy?: boolean;
  hideCommentTypes?: boolean;
  showSegmentsWhenBankwideSelected?: boolean;
  showAllCoachingFormOption?: boolean;
  resetFiltersOnMount?: boolean;
  useSegmentParents?: boolean;
  useNewContainer?: boolean;
  showSocialMediaSource?: boolean;
  showDatePicker?: boolean;
  showMonthPicker?: boolean;
  isMyAlertsDashboard?: boolean;
  dateRangeDataFetchStatusControlledBy?: 'state' | 'props'
  dateRangeDataFetchStatus?: boolean
}

export interface IFiltersBarState {
  disableDatePicker: boolean;
  allTime: boolean;
  heirarchyValues: string[];
  actionAlertHierarchyValues: string[];
  periodValues: string[];
  isMobile: boolean;
  searchValue: string;
  displaySearchValue: string;
  surveyValue: string;
  segmentValue: string;
  questionValue: string;
  listOfQuestions: string[];
  commentTypeValue: string;
  metricValue: string;
  socialMediaSource: string;
  isResetting: boolean;
  segmentParentValue: string;
  defaultSegmentParentValue?: string;
  defaultSurveyValue?: string;
  defaultSegmentValue?: string;
  defaultHeriarchyValue?: string;
  defaultActionAlertHierarchyValue?: string;
  defaultPeriodValue?: string;
  defaultSearchValue?: string;
  defaultQuestionValue?: string;
  defaultCommentTypeValue?: string;
  defaultMetricValue?: string;
  defaultSocialMediaSource?: string;
  dateRange?: string;
  startDateRange?: Date;
  endDateRange?: Date;
  allPeriodsWarning: boolean
  enableAllPeriodsWarning: boolean
  enableDateRangeSelection: boolean
  isDataFetching: boolean
}

export class FiltersBar extends React.Component<
  IIFiltersBarProps,
  IFiltersBarState
> {
  state: IFiltersBarState = {
    heirarchyValues: [],
    actionAlertHierarchyValues: [],
    periodValues: [],
    isMobile: false,
    surveyValue: '',
    segmentValue: '',
    searchValue: '',
    socialMediaSource: '',
    displaySearchValue: '',
    questionValue: '',
    commentTypeValue: '',
    metricValue: '',
    segmentParentValue: '',
    isResetting: false,
    disableDatePicker: true,
    allTime: true,
    allPeriodsWarning: false,
    enableAllPeriodsWarning: false,
    enableDateRangeSelection: false,
    isDataFetching: false,
    listOfQuestions: [],
  };

  constructor(props) {
    super(props);
    this.updateSearchValue = this.updateSearchValue.bind(this);
  }

  resizeListener = _.debounce(() => this.reconstituteFilters(), 50);
  updateSearchValueDebounce = _.debounce(
    (searchValue) =>
      this.updateFiltersValue('search', 'searchValue', searchValue),
    1500
  );

  componentWillMount() {
    const { showAllCoachingFormOption = false } = this.props;

    HierarchyDataSource.setShowAllCoachingFormOption(showAllCoachingFormOption);

    if (this.props.resetFiltersOnMount) {
      this.resetFilters();
    }

    userData.filtersListen((filters) => {
      const defaultSurveyValue = filters.survey;
      const defaultSegmentValue = filters.segment;
      const defaultQuestionValue = filters.oequestion;
      const defaultCommentTypeValue = filters.commentType;
      const defaultSearchValue = filters.search;
      const defaultMetricValue = filters.metric || '';
      const defaultSegmentParentValue = filters.segmentParent;
      const defaultHeriarchyValue = filters.hier;
      const defaultActionAlertHierarchyValue = 'My_alerts';
      const defaultPeriodValue = filters.period;
      const enableAllPeriodsWarning = filters.allPeriodsWarning;
      const enableDateRangeSelection = filters.enableDateRangeSelection;
      let { displaySearchValue } = this.state;

      if (displaySearchValue === '' && defaultSearchValue) {
        displaySearchValue = defaultSearchValue;
      }

      this.setState({
        defaultSurveyValue,
        defaultSegmentValue,
        defaultQuestionValue,
        defaultSearchValue,
        defaultCommentTypeValue,
        defaultMetricValue,
        defaultSegmentParentValue,
        defaultHeriarchyValue,
        defaultPeriodValue,
        displaySearchValue,
        defaultActionAlertHierarchyValue,
        enableAllPeriodsWarning,
        enableDateRangeSelection,
      });
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeListener);
    this.reconstituteFilters();
    this.setInitialDateRangeState();
    this.updateFiltersValue('dateRange', 'dateRange', 'N/A');
    this.setState({ disableDatePicker: true });
    window.addEventListener('setInitialDate', (evt: CustomEvent) => {
      if (evt.detail) {
        this.setInitialDateRangeState(false, evt.detail);
      }
    });
    window.addEventListener('hideAllPeriodsWarning', (evt: CustomEvent) => {
      if (evt.type === 'hideAllPeriodsWarning') {
        this.setState({ allPeriodsWarning: false });
      }
    });
    window.addEventListener('allDataLoaded', (evt: CustomEvent) => {
      if (evt.type === 'allDataLoaded') {
        this.setState({ isDataFetching: false });
      }
    });
  }

  componentDidUpdate(
    prevProps: Readonly<IIFiltersBarProps>,
    prevState: Readonly<IFiltersBarState>,
    snapshot?: any
  ) {
    if (prevState.disableDatePicker !== this.state.disableDatePicker) {
      if (this.state.disableDatePicker) {
        this.updateFiltersValue('dateRange', 'dateRange', 'N/A');
      } else {
        this.setInitialDateRangeState(true);
      }
    }
    if (prevProps.dateRangeDataFetchStatus !== this.props.dateRangeDataFetchStatus) {
      this.setState({
        isDataFetching: this.props.dateRangeDataFetchStatus
      })
    }
  }


  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeListener);
  }

  updateFiltersValue = <K extends keyof IFilters, J extends keyof IFiltersBarState>(filterKey: K, stateKey: J, value: IFiltersBarState[J], forceUpdate?: boolean, keepValueAsAnArray?: boolean) => {
    let filterValue;
    if (keepValueAsAnArray) {
      filterValue = value;
    } else {
      if (Array.isArray(value)) {
        filterValue = [...value].pop(); //get latest value for filter save
      } else {
        filterValue = value;
      }
    }

    //NOTE: If on the coaching overview page and the user doesn't have a valid default hier value, set to ALL.
    if (
      filterKey === 'hier' &&
      !filterValue &&
      window.location.href.indexOf('coachingoverview') !== -1
    ) {
      filterValue = 'ALL';
    }

    //Update Filter
    let currentUpdate = { [filterKey]: filterValue };

    if (filterKey === 'period') {
      const periodComparisonKey = 'periodComparison';
      const periodConparisonValue = '';
      const periodComparisonUpdate = {
        [periodComparisonKey]: periodConparisonValue,
      };
      currentUpdate = _.merge({}, currentUpdate, periodComparisonUpdate);
    }

    //NOTE: When updating the hierarchy, if it is not bankwide we need to reset the segment filter
    if (
      filterKey === 'hier' &&
      filterValue &&
      filterValue.toLowerCase() !== 'bankwide_0'
    ) {
      const segmentFilterKey = 'segment';
      const segmentFilterValue = '';
      const segmentParentKey = 'segmentParent';
      const segmentParentValue = '';
      const segmentUpdate = {
        [segmentFilterKey]: segmentFilterValue,
        [segmentParentKey]: segmentParentValue,
      };

      currentUpdate = _.merge({}, currentUpdate, segmentUpdate);
      this.setState({ segmentParentValue: undefined, segmentValue: undefined });
    }

    userData.updateFilters(currentUpdate, forceUpdate ? forceUpdate : false);

    //Update State
    if (this.state[stateKey] !== value) {
      const update: any = {};
      update[stateKey] = value;
      this.setState(update);
    }
  };

  reconstituteFilters() {
    const isMobile = window.innerWidth <= 992;

    this.setState({ isMobile });
  }

  setFilters(filters: IFilters) {
    const surveyValue = filters.survey;
    const segmentValue = filters.segment;
    const searchValue = filters.search;
    const questionValue = filters.oequestion;
    const commentTypeValue = filters.commentType;
    const metricValue = filters.metric || '';
    const segmentParentValue = filters.segmentParent;
    const heirarchyValues = filters.hier ? [filters.hier] : [];
    const actionAlertHierarchyValues = ['My_alerts'];
    const periodValues = filters.period ? [filters.period] : [];
    const enableAllPeriodsWarning = filters.allPeriodsWarning ? filters.allPeriodsWarning : false;
    const enableDateRangeSelection = filters.enableDateRangeSelection ? filters.enableDateRangeSelection : false;

    this.setState({
      surveyValue,
      segmentValue,
      heirarchyValues,
      actionAlertHierarchyValues,
      searchValue,
      questionValue,
      commentTypeValue,
      metricValue,
      periodValues,
      segmentParentValue,
      enableAllPeriodsWarning,
      enableDateRangeSelection
    });
  }

  resetURL() {
    if (window.location.href.indexOf('?survey=') !== -1) {
      window.location.replace('/coachingoverview?reset=Yes')
    }
  }

  resetFilters() {
    this.resetURL();
    this.setState({ isResetting: true });

    userData.resetFilters().then((filters) => {
      this.setFilters(filters);
      HierarchyDataSource.sync(true);
      HierarchyMyAlertsDataSource.sync(true, 'My_alerts');
      // PeriodsDataSource.sync(true)
      SegmentsDataSource.sync(true);
      // SegmentParentsDataSource.sync(true)
      SurveysDataSource.sync(true);
      // QuestionsDataSource.sync(true)
      // CommentTypesDataSource.sync(true)
      this.setState({ isResetting: false, disableDatePicker: true });
    });
  }

  getPeriodsFilter(isMobile = this.state.isMobile) {
    const { showDatePicker, showMonthPicker } = this.props;
    const {
      enableAllPeriodsWarning,
      enableDateRangeSelection,
      isDataFetching,
    } = this.state;
    if (showMonthPicker && enableDateRangeSelection) {
      return (
        <CustomPeriodsFilter
          showMonthPicker
          isDataLoading={isDataFetching}
          dateRange={this.state.dateRange}
          useMobileMode={isMobile}
          values={this.state.periodValues}
          defaultValue={this.state.defaultPeriodValue}
          onChange={(periodValues) => {
            if (enableAllPeriodsWarning && periodValues.includes('ALL')) {
              this.setState({ allPeriodsWarning: true });
            }
            this.updateFiltersValue('period', 'periodValues', periodValues);
          }}
          startDateRange={this.state.startDateRange}
          endDateRange={this.state.endDateRange}
          disableDatePicker={this.state.disableDatePicker}
          updateDateRange={(startDate, endDate) => {
            this.updateDateRange(startDate, endDate);
          }}
        />
      );

    }
    if (!showDatePicker) {
      return (
        <PeriodsFilter
          useMobileMode={isMobile}
          values={this.state.periodValues}
          defaultValue={this.state.defaultPeriodValue}
          onChange={(periodValues) => {
            if (enableAllPeriodsWarning && periodValues.includes('ALL')) {
              this.setState({ allPeriodsWarning: true });
            }
            this.updateFiltersValue('period', 'periodValues', periodValues);
          }}
        />
      );
    } else {
      return null;
    }
  }

  getDatePicker() {
    // todo: put labels in the DatePicker component
    const { showDatePicker } = this.props;
    if (showDatePicker) {
      return (
        <>
          <div className="datepicker-container">
            <span>From: </span>
            <DatePicker
              selected={this.state.startDateRange}
              onChange={(date) => {
                this.updateDateRange(date, this.state.endDateRange);
              }}
              selectsStart
              startDate={this.state.startDateRange}
              endDate={this.state.endDateRange}
              className={
                this.state.disableDatePicker
                  ? 'margin-bottom text-muted'
                  : 'margin-bottom'
              }
            />
            <span>To: </span>
            <DatePicker
              selected={this.state.endDateRange}
              onChange={(date) => {
                this.updateDateRange(this.state.startDateRange, date);
              }}
              selectsEnd
              startDate={this.state.startDateRange}
              endDate={this.state.endDateRange}
              minDate={this.state.startDateRange}
              className={
                this.state.disableDatePicker
                  ? 'margin-bottom text-muted'
                  : 'margin-bottom'
              }
            />
            <div style={{ marginTop: '1rem' }}>
              <CheckBox
                onChange={() =>
                  this.setState({
                    disableDatePicker: !this.state.disableDatePicker,
                  })
                }
                isEnabled
                isChecked={this.state.disableDatePicker}
                label="All Time"
              />
            </div>
          </div>
        </>
      );
    }
  }
  getMonthPicker() {
    // todo: put labels in the DatePicker component
    const { showMonthPicker } = this.props;
    if (showMonthPicker) {
      return (
        <>
          <div className="datepicker-container">
            <span>From: </span>
            <DatePicker
              selected={this.state.startDateRange}
              onChange={(date) => {
                this.updateDateRange(date, this.state.endDateRange);
              }}
              selectsStart
              startDate={this.state.startDateRange}
              endDate={this.state.endDateRange}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              className={
                this.state.disableDatePicker
                  ? 'margin-bottom text-muted'
                  : 'margin-bottom'
              }
            />
            <span>To: </span>
            <DatePicker
              selected={this.state.endDateRange}
              onChange={(date) => {
                this.updateDateRange(this.state.startDateRange, date);
              }}
              selectsEnd
              startDate={this.state.startDateRange}
              endDate={this.state.endDateRange}
              minDate={this.state.startDateRange}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              className={
                this.state.disableDatePicker
                  ? 'margin-bottom text-muted'
                  : 'margin-bottom'
              }
            />
            <div style={{ marginTop: '1rem' }}>
              <CheckBox
                onChange={() =>
                  this.setState({
                    disableDatePicker: !this.state.disableDatePicker,
                  })
                }
                isEnabled
                isChecked={this.state.disableDatePicker}
                label="All Time"
              />
            </div>
          </div>
        </>
      );
    }
  }

  getHierarchyFilter(isMobile = this.state.isMobile) {
    const { hideHeirarchy, showAllCoachingFormOption } = this.props;

    if (hideHeirarchy) {
      return null;
    }

    return (
      <DataMultiBtnSelect
        placeholder="Hierarchy"
        source={HierarchyDataSource}
        hidePopoverOnClear
        hidePopoverOnLeadNodeSelect
        useMobileMode={isMobile}
        persistLabel={true}
        disableClearOnFirstSelect
        showAllCoachingFormOption={showAllCoachingFormOption}
        defaultValue={this.state.defaultHeriarchyValue}
        values={this.state.heirarchyValues}
        onChange={(heirarchyValues) =>
          this.updateFiltersValue('hier', 'heirarchyValues', heirarchyValues)
        }
        hideFirstSelectWhen={(source) =>
          source.length >= 1 && source[0].value.toLowerCase() === 'bankwide_0'
        }
      />
    );
  }

  getHierarchyFilterForMyAlerts(isMobile = this.state.isMobile) {
    const { hideHeirarchy, showAllCoachingFormOption } = this.props;

    if (hideHeirarchy) {
      return null;
    }

    return (
      <DataMultiBtnSelect
        placeholder="View"
        source={HierarchyMyAlertsDataSource}
        hidePopoverOnClear
        hidePopoverOnLeadNodeSelect
        useMobileMode={isMobile}
        persistLabel={true}
        disableClearOnFirstSelect
        showAllCoachingFormOption={showAllCoachingFormOption}
        defaultValue={this.state.defaultActionAlertHierarchyValue}
        values={this.state.actionAlertHierarchyValues}
        onChange={(actionAlertHierarchyValues) =>
          this.updateFiltersValue(
            'actionAlertHierarchy',
            'actionAlertHierarchyValues',
            actionAlertHierarchyValues
          )
        }
        hideFirstSelectWhen={(source) =>
          source.length >= 1 && source[0].value.toLowerCase() === 'all'
        }
      />
    );
  }

  getSurveyFilter(isMobile = this.state.isMobile) {
    const { hideSurveys } = this.props;

    if (hideSurveys) {
      return null;
    }

    return (
      <DataBtnSelect
        persistLabel
        useMobileMode={isMobile}
        source={SurveysDataSource}
        value={this.state.surveyValue}
        defaultValue={this.state.defaultSurveyValue}
        onChange={(surveyValue) => {
          if (window.location.href.indexOf('coachingoverview') !== -1) {
            window.history.pushState({}, document.title, '/' + 'coachingoverview');
          }
          this.updateFiltersValue('survey', 'surveyValue', surveyValue)
        }
        }
        header="Survey Type"
      />
    );
  }

  getSegmentFilter(isMobile = this.state.isMobile) {
    const {
      hideSegments,
      showSegmentsWhenBankwideSelected,
      useSegmentParents,
    } = this.props;
    const { heirarchyValues } = this.state;
    const heirarchyValue = heirarchyValues[heirarchyValues.length - 1] || '';
    const isBankwide = heirarchyValue.toLowerCase().indexOf('bankwide_0') >= 0;
    const bankwideRequirementNotMet =
      showSegmentsWhenBankwideSelected && !isBankwide;

    if (hideSegments || bankwideRequirementNotMet) {
      return null;
    }

    let segmentParentValue = this.state.segmentParentValue;
    if (!segmentParentValue) {
      segmentParentValue = '';
    }

    let segmentChildValue = this.state.segmentValue;
    if (!segmentChildValue) {
      segmentChildValue = '';
    }

    if (useSegmentParents) {
      return (
        <DataBtnSelect
          persistLabel
          useMobileMode={isMobile}
          source={SegmentParentsDataSource}
          value={segmentParentValue}
          defaultValue={this.state.defaultSegmentParentValue}
          onChange={(newSegmentParentValue) =>
            this.updateFiltersValue(
              'segmentParent',
              'segmentParentValue',
              newSegmentParentValue
            )
          }
          header="Segment"
        />
      );
    } else {
      return (
        <DataBtnSelect
          clearable
          persistLabel
          groupMode
          useMobileMode={isMobile}
          source={SegmentsDataSource}
          value={segmentChildValue}
          defaultValue={this.state.defaultSegmentValue}
          onChange={(segmentValue) =>
            this.updateFiltersValue('segment', 'segmentValue', segmentValue)
          }
          header="Segment"
        />
      );
    }
  }

  getMetricFilter(isMobile = this.state.isMobile) {
    const { hideMetrics } = this.props;

    if (hideMetrics) {
      return null;
    }

    return (
      <BtnSelect
        clearable
        persistLabel
        useMobileMode={isMobile}
        options={[
          { value: 'T2', label: '% Top 2' },
          { value: 'M2', label: '% Middle 2' },
          { value: 'B3', label: '% Bottom 3' },
          { value: '7', label: '% 7' },
          { value: '6', label: '% 6' },
          { value: '5', label: '% 5' },
          { value: '4', label: '% 4' },
          { value: '3', label: '% 3' },
          { value: '2', label: '% 2' },
          { value: '1', label: '% 1' },
        ]}
        value={this.state.metricValue}
        defaultValue={this.state.defaultMetricValue}
        onChange={(metricValue) =>
          this.updateFiltersValue('metric', 'metricValue', metricValue)
        }
        header="Measure"
      />
    );
  }

  getQuestionsFilter(isMobile = this.state.isMobile) {
    const { hideQuestions } = this.props;

    if (hideQuestions) {
      return null;
    }

    let questionVal = this.state.questionValue;
    if (!questionVal) {
      questionVal = '';
    }

    return (
      <DataBtnSelect
        clearable
        clearLabel="All Questions"
        persistLabel={true}
        useMobileMode={isMobile}
        source={QuestionsDataSource}
        value={questionVal}
        defaultValue={this.state.defaultQuestionValue}
        onChange={(questionValue) =>
          this.updateFiltersValue('oequestion', 'questionValue', questionValue)
        }
        header="Question"
      />
    );
  }

  getCommentTypesFilter(isMobile = this.state.isMobile) {
    const { hideCommentTypes } = this.props;

    if (hideCommentTypes) {
      return null;
    }

    //NOTE: When reset filters is clicked, the value turns to undefined which doesn't set the value to All Comment Types.
    //NOTE: This resets to the all comment types option.
    let commentType = this.state.commentTypeValue;
    if (!commentType) {
      commentType = '';
    }

    return (
      <DataBtnSelect
        clearable
        clearLabel="All Comment Types"
        persistLabel
        groupMode
        useMobileMode={isMobile}
        source={CommentTypesDataSource}
        value={commentType}
        defaultValue={this.state.defaultCommentTypeValue}
        onChange={(commentTypeValue) =>
          this.updateFiltersValue(
            'commentType',
            'commentTypeValue',
            commentTypeValue
          )
        }
        header="Comment Type"
      />
    );
  }

  getSocialMediaSourceFilter(isMobile = this.state.isMobile) {
    const { showSocialMediaSource } = this.props;

    if (!showSocialMediaSource) {
      return null;
    }

    //NOTE: When reset filters is clicked, the value turns to undefined which doesn't set the value to All Comment Types.
    //NOTE: This resets to the all comment types option.
    let socialMediaSource = this.state.socialMediaSource;
    if (!socialMediaSource) {
      socialMediaSource = '';
    }

    return (
      <DataBtnSelect
        clearable
        clearLabel="All Social Media Sites"
        persistLabel
        useMobileMode={isMobile}
        source={SourcesDataSource}
        value={socialMediaSource}
        defaultValue={this.state.defaultSocialMediaSource}
        onChange={(socialMedia) =>
          this.updateFiltersValue(
            'socialMedia',
            'socialMediaSource',
            socialMedia
          )
        }
        header="Social Media Source"
      />
    );
  }

  exportCSV() {
    const filters = userData.getFilters();
    const client = userData.getUserDataFromSession('client');
    const userId = userData.getUserDataFromSession('token').userId
    const saveData = ((() => {
      const a = document.createElement('a');
      document.body.appendChild(a);
      return (data, fileName) => {
          const blob = new Blob([data], {type: 'octet/stream'})
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
      };
    })());

    $.ajax({
      url: '/scripts/coaching_forms/download_interviews_csv',
      type: 'post',
      data: {
        filterClient : client,
        filterUserID : userId,
        filterPeriod : filters.period,
        filterQuestion : filters.question,
        filterSecurity : filters.securityType,
        filterSurvey : filters.survey,
        filterHeir : filters.hier,
        filterSegment : filters.segment,
        filterStat : filters.stat,
        filterSearch : filters.search,
        filterMeasure : filters.measure,
        filterPeriodComparison : filters.periodComparison
      },
      success(data) {
          const fileName = client + '-' + filters.period + '.csv';
          saveData(data, fileName);
        }

    });
  }

  getResetBtn(isMobile = this.state.isMobile) {
    const { isResetting } = this.state;

    return (
      <div>
        <Button
          className={`bl-btn ${isMobile ? 'text-white' : ''} ${
            isResetting ? 'spin-icon' : ''
          }`}
          color={isMobile ? 'warning' : 'light'}
          onClick={() => this.resetFilters()}
        >
          Reset Settings
        </Button>
      </div>
    );
  }

  getSearch(isMobile = this.state.isMobile) {
    const { hideSearch } = this.props;
    const { searchValue } = this.state;
    const header = (
      <>
        <span className="fw-600">Search</span>
        {searchValue && (
          <>
            <span className="fw-600">:&nbsp;</span>
            <span>{searchValue}</span>
          </>
        )}
      </>
    );

    if (hideSearch) {
      return null;
    }

    return (
      <div
        className="input-field inner-addon right-addon"
        style={{ position: 'relative', display: 'inline-block' }}
      >
        <input
          placeholder="Search: "
          type="text"
          value={this.state.displaySearchValue}
          onChange={(e) => this.updateSearchValue(e.currentTarget.value)}
          defaultValue={this.state.defaultSearchValue}
          style={{ width: '200px' }}
        />
        <FontAwesomeIcon
          icon="search"
          muted
          style={{
            verticalAlign: 'middle',
            position: 'absolute',
            top: '15px',
            left: '180px',
          }}
        />
      </div>
    );
  }

  updateSearchValue(displaySearchValue: string) {
    this.setState({ displaySearchValue });

    this.updateSearchValueDebounce(displaySearchValue);
  }

  // This method is supposed to be run only after Submit button
  // has been clicked.
  updateDateRange(startDate: Date, endDate: Date) {
    const fromDate = format(startDate, 'yyyy/MM/dd');
    const toDate = format(endDate, 'yyyy/MM/dd');


    const dateRange = fromDate + '-' + toDate;
    this.updateFiltersValue('dateRange', 'dateRange', dateRange, true);
    this.setState(
      {
        startDateRange: startDate,
        endDateRange: endDate,
        disableDatePicker: false,
      },
      () => {
        let isDataFetching = true;
        if (this.props.dateRangeDataFetchStatusControlledBy && this.props.dateRangeDataFetchStatusControlledBy === 'props') {
          isDataFetching = this.props.dateRangeDataFetchStatus;
        }
        this.setState({
          isDataFetching
        });
      }
    );
  }

  setInitialDateRangeState(
    updateRange?: boolean,
    proposedInitialDate?: string
  ) {
    // NOTE: If first time loading Date Picker, date range should be default to current month
    // as in firstDayOfMonth - lastDayOfMonth
    const currentDate = new Date();
    let initialDate;
    if (!proposedInitialDate) {
      initialDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
    } else {
      initialDate = new Date(
        parseInt(proposedInitialDate.slice(0, 4), 10),
        parseInt(proposedInitialDate.slice(5, 7), 10) - 1,
        parseInt(proposedInitialDate.slice(8, 10), 10)
      );
    }
    let startDate = new Date();
    let endDate = new Date();
    if (
      userData.getFilters().dateRange &&
      userData.getFilters().dateRange !== 'N/A'
    ) {
      // If there is already a filter, set with these values
      const dateRange = userData.getFilters().dateRange;
      startDate = new Date(dateRange.split('-')[0]);
      endDate = new Date(dateRange.split('-')[1]);
      this.setState({
        startDateRange: startDate,
        endDateRange: currentDate,
      });
      this.updateDateRange(startDate, endDate);
    } else {
      this.setState({
        startDateRange: initialDate,
        endDateRange: currentDate,
      });
      if (updateRange) {
        this.updateDateRange(initialDate, currentDate);
      }
    }
  }

  getAllPeriodsWarning() {
    return (
      <Modal className="w-75 h-25 p-5" open={this.state.allPeriodsWarning}>
        <p
          className="text-center text-info"
          style={{
            fontSize: '2.25rem',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          Thank you for your patience as we calculate data for all periods.
        </p>
      </Modal>
    );
  }

  render() {
    const { isMobile } = this.state;
    const {
      useNewContainer = false,
      isMyAlertsDashboard,
      showDatePicker,
      showMonthPicker,
        children
    } = this.props;
    const containerClass = useNewContainer ? 'containerv2' : 'container-old';

    return (
      <>
        {showDatePicker && (
          <div className="containerv2">
            <span>Date Range: </span>
          </div>
        )}
        <section className="blacklight filters-bar-container">
          <section
            className={`${containerClass} filters-bar form-inline align-items-sm-baseline`}
          >
            {!isMobile && (
              <>
                {this.getAllPeriodsWarning()}
                {this.getPeriodsFilter()}
                {this.getDatePicker()}
                {!isMyAlertsDashboard && this.getHierarchyFilter()}
                {isMyAlertsDashboard && this.getHierarchyFilterForMyAlerts()}
                {this.getSurveyFilter()}
                {this.getSegmentFilter()}
                {this.getMetricFilter()}
                {this.getCommentTypesFilter()}
                {this.getSocialMediaSourceFilter()}
                {this.getQuestionsFilter()}
                {this.getSearch()}
                {React.Children.map(children, (child) => {
                  if (React.isValidElement(child)) {
                    return React.cloneElement(child, {
                      onUpdateFilters: this.updateFiltersValue
                    } as any);
                  }
                  return child;
                })}
                {this.getResetBtn()}
              </>
            )}
            {isMobile && (
              <BtnPopover header="Filters">
                <article className="mb-3">{this.getPeriodsFilter()}</article>
                <article className="mb-3">
                  {!isMyAlertsDashboard && this.getHierarchyFilter()}
                  {isMyAlertsDashboard && this.getHierarchyFilterForMyAlerts()}
                </article>
                <article className="mb-3">{this.getSurveyFilter()}</article>
                <article className="mb-3">{this.getSegmentFilter()}</article>
                <article className="mb-3">{this.getMetricFilter()}</article>
                <article className="mb-3">{this.getCommentTypesFilter()}</article>
                <article className="mb-3">{this.getQuestionsFilter()}</article>
                <article className="mb-3">
                  {this.getSocialMediaSourceFilter()}
                </article>
                <article className="mb-3">{this.getSearch()}</article>
                {React.Children.map(children, (child) => {
                  if (React.isValidElement(child)) {
                    return React.cloneElement(child, {
                      onUpdateFilters: this.updateFiltersValue
                    } as any);
                  }
                  return child;
                })}
                <footer className="btn-popover-footer d-flex justify-content-end">
                  {this.getResetBtn()}
                </footer>
              </BtnPopover>
            )}
          </section>
        </section>
      </>
    );
  }
}
